import * as Yup from "yup";
import { ChipInput } from "../../../components";
import { CustomSelect } from "../../../components";
import { RootState } from "@/store/index";
import { connect } from "react-redux";
import { getUpdateMediaSecurity } from "@/store/media/media.action";
import { useFormik } from "formik";
import { ConnectedProps } from "react-redux";
import { MediaSecurityFormData } from "@/database";
import { useOutletContext, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { COUNTRIES } from "@/utils/constants/uiConstants";

const MediaSecurity = ({ media, getUpdateMediaSecurity }: Props) => {
  const searchParams = useSearchParams();

  const outletContext = useOutletContext<{
    handleSaveSecurityDisabled?: (disabled: boolean) => void;
  }>();

  const { handleSaveSecurityDisabled } = outletContext || {
    handleSaveSecurityDisabled: () => {},
  };

  const formik = useFormik<MediaSecurityFormData>({
    enableReinitialize: true,
    validateOnChange: true,
    initialValues: {
      id: media.id,
      perm_view: media.perm_view,
      perm_edit: media.perm_edit,
      perm_clone: media.perm_clone,
      mfk: media.mfk,
      age: media.age,
      gct: media.gct,
      gdt: media.gdt,
      gcl: media.gcl || [],
      gdl: media.gdl || [],
    },
    validationSchema: Yup.object({
      age: Yup.number().required("Age Restriction is required."),
      mfk: Yup.number().required("For Kids is required."),
    }),
    onSubmit: (values) => {
      getUpdateMediaSecurity(values);
    },
  });

  useEffect(() => {
    const handleundo = () => {
      formik.resetForm();
    };

    window.addEventListener("securityUndoClick", handleundo);
    return () => {
      window.removeEventListener("securityUndoClick", handleundo);
    };
  }, []);

  useEffect(() => {
    handleSaveSecurityDisabled &&
      handleSaveSecurityDisabled(!formik.isValid || !formik.dirty);
  }, [formik.isValid, formik.dirty]);

  const handleDetailsSave = (e?: React.FormEvent) => {
    e?.preventDefault();
    formik.validateForm();

    if (!formik.isValid) {
      return;
    }

    formik.submitForm();
  };

  useEffect(() => {
    const handleSave = () => {
      handleDetailsSave();
    };

    window.addEventListener("securitySaveClick", handleSave);
    return () => {
      window.removeEventListener("securitySaveClick", handleSave);
    };
  }, []);
  const getCleanParams = () => {
    const cleanParams = new URLSearchParams();
    for (const [key, value] of searchParams[0].entries()) {
      if (key !== "nextInit" && key !== "navigateOptions" && value) {
        cleanParams.append(key, value);
      }
    }
    return cleanParams;
  };

  return (
    <div style={{ width: "100%" }} className="mb-10 pb-10">
      {/* <div className="d-flex justify-content-end p-3 py-2 align-items-center bg-white sticky-top top-0 border-bottom"> */}
      {/* <div
          className="header_left d-flex gap-2 align-items-center  px-3 py-2 position-fixed w-100 bgGrey"
          style={{ width: '100%', left: 0, top: 0, zIndex: 5 }}
        >
          <button
            type="button"
            aria-label="Close"
            onClick={() => navigate(`/media?${getCleanParams().toString()}`)}
            style={{ border: 'none', background: 'none' }}
          >
            <BackIcon style={{ width: '24px' }} />
          </button>

          <span className="text-uppercase text-primary d-flex align-items-center gap-2">
            video Details
            <Next style={{ width: '14px' }} />
            Details
          </span>
        </div> */}

      {/* <div className="buttons">
          <Button
            className="btn-sm me-2"
            type="outline-primary"
            onClick={() => {
              formik.resetForm();
            }}
            isDisabled={!formik.dirty}
          >
            UNDO
          </Button>
          <Button
            type="primary"
            className="btn btn-primary btn-sm"
            isDisabled={!formik.isValid || !formik.dirty}
            onClick={(e) => {
              handleDetailsSave(e);
            }}
          >
            SAVE
          </Button>
        </div> */}
      {/* </div> */}
      <div className="container-fluid ">
        <div className="py-2">
          <h6>Permission</h6>
          <div className="row py-2">
            <div className="col col-4">
              <CustomSelect
                className="mb-3"
                value={String(formik.values.perm_view)}
                label="View Permissions"
                options={[
                  { label: "Everyone", value: "1" },
                  { label: "Everyone in my Business Unit", value: "2" },
                  { label: "Everyone in my Team", value: "3" },
                  { label: "Uploader Only", value: "4" },
                  { label: "Everyone in my Organization", value: "5" },
                ]}
                disabled={false}
                placeholder="Select View Permissions"
                handleChange={(newValue: any) => {
                  formik.setFieldValue("perm_view", parseInt(newValue.value));
                }}
              />
            </div>
            <div className="col col-4">
              <CustomSelect
                className="mb-3"
                value={`${formik.values.perm_edit}`}
                label="Edit Permissions"
                options={[
                  { label: "Everyone in my Business Unit", value: "1" },
                  { label: "Everyone in my Team", value: "2" },
                  { label: "Uploader Only", value: "3" },
                  { label: "Everyone in my Organization", value: "4" },
                ]}
                disabled={false}
                placeholder="Select Edit Permissions"
                handleChange={(newValue: any) => {
                  formik.setFieldValue("perm_edit", parseInt(newValue.value));
                }}
              />
            </div>
          </div>
          <div className="row">
            <div className="col col-4">
              <CustomSelect
                className="mb-3"
                value={`${formik.values.perm_clone}`}
                label="Clone/Translate Permissions"
                options={[
                  { label: "YES", value: "1" },
                  { label: "NO", value: "2" },
                ]}
                disabled={false}
                placeholder="Select Clone/Translate Permissions"
                handleChange={(newValue: any) => {
                  formik.setFieldValue("perm_clone", parseInt(newValue.value));
                }}
              />
            </div>
          </div>
        </div>
        <div className="py-2">
          <h6>Geo Restriction</h6>
          <div className="row">
            <div className="col col-8">
              <CustomSelect
                className="mt-2"
                value={formik.values.gct}
                label="Mode"
                options={[
                  { label: "Allowed Countries", value: 1 },
                  { label: "Blocked Countries", value: 2 },
                ]}
                disabled={false}
                placeholder="Mode"
                handleChange={(newValue: any) => {
                  formik.setFieldValue("gct", newValue.value);
                }}
              />
              <CustomSelect
                className="mt-2"
                label="Countries"
                options={COUNTRIES}
                disabled={false}
                placeholder="Countries"
                handleChange={(newValue: any) => {
                  const newCountries = [
                    ...new Set(newValue.map((v: any) => v.value)),
                  ];
                  formik.setFieldValue("gcl", newCountries);
                }}
                value={formik.values.gcl}
                multiSelect={true}
                handleClear={() => formik.setFieldValue("gcl", [])}
              />
            </div>
          </div>
        </div>
        <div className="py-2">
          <h6>Playback Restriction</h6>
          <div className="row">
            <div className="col col-8">
              <CustomSelect
                className="mb-3"
                value={formik.values.gdt}
                label="mode"
                options={[
                  { label: "Allowed", value: 1 },
                  { label: "Not Allowed", value: 0 },
                ]}
                disabled={false}
                placeholder="Select Clone/Translate Permissions"
                handleChange={(newValue: any) => {
                  formik.setFieldValue("gdt", newValue.value);
                }}
              />
              <ChipInput
                label="Domain"
                value={formik.values.gdl}
                placeholder="Type here to add Domain"
                handleChipChange={(chip: string | string[], action: string) => {
                  const currentGdl = formik.values.gdl || [];
                  if (action === "add") {
                    const chipsToAdd = typeof chip === "string" ? [chip] : chip;
                    formik.setFieldValue("gdl", [
                      ...new Set([...currentGdl, ...chipsToAdd]),
                    ]);
                  } else if (action === "remove") {
                    const chipsToRemove =
                      typeof chip === "string" ? [chip] : chip;
                    formik.setFieldValue(
                      "gdl",
                      currentGdl.filter(
                        (t: string) => !chipsToRemove.includes(t)
                      )
                    );
                  } else if (action === "clear") {
                    formik.setFieldValue("gdl", []);
                  }
                }}
              />
            </div>
          </div>
        </div>
        <div className="py-2">
          <h6>Content rating/ Certification</h6>
          <div className="row">
            <div className="col col-4">
              <CustomSelect
                className="mb-3"
                value={formik.values.mfk}
                label="Made for Kids"
                options={[
                  { label: "Yes", value: 1 },
                  { label: "No", value: 0 },
                ]}
                disabled={false}
                showRequired={true}
                placeholder="Select Clone/Translate Permissions"
                handleChange={(newValue: any) => {
                  formik.setFieldValue("mfk", parseInt(newValue.value));
                }}
              />
            </div>
            <div className="col col-4">
              <CustomSelect
                className="mb-3"
                value={formik.values.age}
                label="Age Restricted Videos(18+)"
                options={[
                  { label: "Yes", value: 1 },
                  { label: "No", value: 0 },
                ]}
                disabled={false}
                showRequired={true}
                placeholder="Select Clone/Translate Permissions"
                handleChange={(newValue: any) => {
                  formik.setFieldValue("age", newValue.value);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapState = (state: RootState) => ({
  media: state.media.mediaDetails.media,
  isLoading: state.media.mediaDetails.isLoading,
});

const mapDispatch = {
  getUpdateMediaSecurity,
};

const connector = connect(mapState, mapDispatch);
type Props = ConnectedProps<typeof connector>;
export default connector(MediaSecurity);
